"use strict";

module.exports = {
  template:
  '<a>' +
  '  <i class="fa fa-pencil fa-circle-thinner"></i>' +
  '</a>'
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/components/emil-button-edit.js